// extracted by mini-css-extract-plugin
export default {"History":"History_History__BE32C","Histories":"History_Histories__06rkW","HistoryWrapper":"History_HistoryWrapper__ngOGi"};